import Form from '../classes/form';
import Notification from "../classes/notification";
import Countdown from "../components/countdown";
import Confetti from "../components/confetti";

window.Form = Form;
window.Notification = Notification;
window.Countdown = Countdown;


class TemplateEngine {
    constructor() {
        let self = this;
        $('div[data-template]').each(function () {
            let element = $(this);
            let template = element.data('template');
            self.call('block_' + template, element);
        });

        $('input[name=donation_amount]').on('change', function () {
            $(this).closest('form').find('input[name=amount]').val($(this).val());
        });

        self.renderSummary();
    }

    renderSummary() {
        $('.summary-container').each(function () {
            let self = $(this);
            let action = self.data('action');
            $.ajax({
                type: 'GET',
                url: action,
                async: true,
                cache: false,
                processData: false,
                contentType: false,
                success: function (data) {
                    self.html(data.view);
                    return true;
                }, error: function (data) {
                    return false;
                }
            });
        });
    }

    call(fn, ...args) {
        try {
            this[fn](...args);
        } catch (e) {
            //
        }
    }

    /**
     * Donation form
     *
     * @param element
     */
    block_7e729e7e3c534cbf918a45b5540afa84(element) {
        let self = this;
        element.find('.btn-submit').on('click', function () {
            formAjax(element.find('form'), false);
            setTimeout(function () {
                self.renderSummary()
            }, 1000);
        });

        $('.select-amount').on('change', function () {
            let input = $(this);
            self.renderSelectAmount(element, input);
        });

        $('.select-amount:checked').each(function () {
            let input = $(this);
            self.renderSelectAmount(element, input);
        });

        setTimeout(function () {
            let amount = $(element).find('input[name=donation_amount]').val();
            element.find('input[name=amount]').val(amount);
        }, 500);

        $('.donation-tip-container').each(function () {
            let container = $(this);
            self.recalculateDonationSummary(element);
            self.renderCustomTip(container, $(element).find('input[name=custom_tip]'));
            $(element).find('input[name=donation_amount]').on('input', function () {
                self.recalculateDonationSummary(element);
            });

            $(element).find('input[name=custom_tip]').on('change', function () {
                self.recalculateDonationSummary(element);
            });

            $(element).find('input[name=custom_tip_amount]').on('input', function () {
                self.renderTipSummary(element, $(element).find('input[name=amount]').val(), $(this).val());
            });

            $(element).find('input[name=percentage_tip_amount]').on('input', function () {
                self.renderTipSummary(element, $(element).find('input[name=amount]').val(), $(this).val());
            });

            container.find('input[name=custom_tip]').on('change', function () {
                self.renderCustomTip(container, $(this));
            })
        })
    }

    block_f08f117f24394e43b76f14cacb617780(element) {
        let primary = element.find('.confetti-effect-container').data('primary-color');
        let secondary = element.find('.confetti-effect-container').data('secondary-color');
        let time = element.find('.confetti-effect-container').data('duration') || 5;

        let colors = [primary, secondary];
        if (element.find('.confetti-effect-container').data('goal-reached') === true && window.is_modal_request === false) {
            new Confetti(colors, time);
        }
    }

    /**
     * MFR Countdown block
     *
     * @param element
     */
    block_cb0f1a877f324dd2bd41951d5b065bf5(element) {
        this.countdown(element);
    }

    /**
     * Countdown block
     *
     * @param element
     */
    block_adc8404e44bb48f3a0fb090a81bad6c5(element) {
        this.countdown(element);
    }

    submitFormOnChange(element, selector) {
        $(document).on('change', selector, function () {
            $(element).find('form').submit();
        });

        $(document).ready(function () {
            $(element).find('form').submit();
        });
    }

    block_6f6a2ebdf4964d8ba6973cb12f28e86a(element) {
        let self = this;
        setTimeout(function () {
            self.submitFormOnChange(element, 'input[name="listing"]');
        }, 1500);

    }

    block_c76712f92d774bcea4723919a45d3b52(element) {
        let self = this;
        setTimeout(function () {
            self.submitFormOnChange(element, 'select[name="level"]');
        }, 1500);
    }

    block_166139446e58403ea511e847f840d795(element) {
        this.timeRemaining(element);
    }

    block_3947218c64cb11ebae930242ac130002(element) {
        this.timeRemaining(element);
    }

    timeRemaining(element) {
        element.find('.time-remaining').each(function () {
            let self = $(this);
            let endTime = parseInt(self.data('timestamp')) * 1000;
            let intervalId = setInterval(function () {
                let now = Date.now();
                let timeLeft = (endTime - Date.now());

                if (timeLeft < 0) {
                    timeLeft = 0;
                    clearInterval(intervalId);
                }
                self.text(humanizeDuration(timeLeft, {round: true, largest: 2, language: $('html').attr('lang')}));
            }, 1000);
        });
    }

    /**
     * Render tip summary
     *
     * @param element
     * @param amount
     * @param tip
     */
    renderTipSummary(element, amount, tip) {
        if (amount && amount.length === 0) {
            amount = 0;
        }

        let percentage = element.find('input[name=percentage_tip_amount]').val();

        let isCustomAmount = element.find('input[name=custom_tip]:checked');
        if (isCustomAmount.length > 0) {
            isCustomAmount = true;
            tip = parseFloat(element.find('input[name=custom_tip_amount]').val() || 0);
        } else {
            isCustomAmount = false;
            tip = parseFloat(amount) * (parseFloat(tip) / 100);

        }


        amount = parseFloat(amount);
        if (isNaN(amount)) {
            amount = 0;
        }
        tip = parseFloat(tip);
        if (isNaN(tip)) {
            tip = 0;
        }

        $(element).find('.tip-donation').text('$' + amount.toFixed(2));
        $(element).find('.tip-amount').text('$' + tip.toFixed(2));

        if (!isCustomAmount) {
            $(element).find('.tip-percentage').text(`(${percentage}%)`);
        }

        let total = (parseFloat(amount) + parseFloat(tip));
        $(element).find('.tip-total').text('$' + total.toFixed(2));
    }

    recalculateDonationSummary(element) {
        let isCustomAmount = element.find('input[name=custom_tip]:checked');

        let tip = 0;
        if (isCustomAmount.length > 0) {
            tip = $(element).find('input[name=custom_tip_amount]').val();
        } else {
            tip = $(element).find('input[name=percentage_tip_amount]').val();
        }

        if (isNaN(tip) || tip.length === 0) {
            tip = 0;
        }

        this.renderTipSummary(element, $(element).find('input[name=donation_amount]').val(), tip);
    }

    renderCustomTip(element, input) {
        if (input.is(':checked')) {
            $(element).find('.custom-tip-container').removeClass('d-none');
            $(element).find('.percentage-tip-container').addClass('d-none');
        } else {
            $(element).find('.custom-tip-container').addClass('d-none');
            $(element).find('.percentage-tip-container').removeClass('d-none');
        }
    }

    renderSelectAmount(element, input) {
        let amount = input.data('amount');
        if (parseInt(input.data('change-amount')) === 1) {
            element.find('input[name=donation_amount]').prop("disabled", false);
        } else {
            element.find('input[name=donation_amount]').prop("disabled", true);
        }
        element.find('input[name=donation_amount]').val(amount);
        element.find('input[name=amount]').val(amount);
        this.recalculateDonationSummary(element);
    }

    countdown(element) {
        let future = parseInt(element.find('input[name="datetime"]').val()) * 1000;
        setInterval(function () {
            let countdown = Countdown(
                null,
                future,
                Countdown.MONTHS | Countdown.DAYS | Countdown.HOURS | Countdown.MINUTES | Countdown.SECONDS
            );

            if (countdown['value'] > 0) {
                element.find('.month').text(countdown['months']);
                element.find('.day').text(countdown['days']);
                element.find('.hour').text(countdown['hours']);
                element.find('.minute').text(countdown['minutes']);
                element.find('.second').text(countdown['seconds']);
            } else {
                element.find('.month').text('0');
                element.find('.day').text('0');
                element.find('.hour').text('0');
                element.find('.minute').text('0');
                element.find('.second').text('0');
            }

            if (parseInt(countdown['months']) === 1) {
                element.find('.month-word').text(element.find('.month-word').data('singular'));
            } else {
                element.find('.month-word').text(element.find('.month-word').data('plural'));
            }

            if (parseInt(countdown['days']) === 1) {
                element.find('.day-word').text(element.find('.day-word').data('singular'));
            } else {
                element.find('.day-word').text(element.find('.day-word').data('plural'));
            }

            if (parseInt(countdown['hours']) === 1) {
                element.find('.hour-word').text(element.find('.hour-word').data('singular'));
            } else {
                element.find('.hour-word').text(element.find('.hour-word').data('plural'));
            }

            if (parseInt(countdown['minutes']) === 1) {
                element.find('.minute-word').text(element.find('.minute-word').data('singular'));
            } else {
                element.find('.minute-word').text(element.find('.minute-word').data('plural'));
            }

            if (parseInt(countdown['seconds']) === 1) {
                element.find('.second-word').text(element.find('.second-word').data('singular'));
            } else {
                element.find('.second-word').text(element.find('.second-word').data('plural'));
            }

        }, 1000);
    }
}


export default TemplateEngine;
